import React, { useState } from 'react';
import { Box, Button, Typography, Alert, Snackbar } from '@mui/material';
import ExitToAppIcon from '@mui/icons-material/ExitToApp';
import WarningIcon from '@mui/icons-material/Warning';
import useIsMobile from '../hooks/useIsMobile';
import { useAuth } from '../contexts/AuthContext';

const ImpersonationBanner: React.FC = () => {
  const { isImpersonating, impersonatorName, user, stopImpersonation } = useAuth();
  const { isMobile } = useIsMobile();
  const [errorMsg, setErrorMsg] = useState('');

  if (!isImpersonating) {
    return null;
  }

  const handleStopImpersonation = async () => {
    try {
      await stopImpersonation();
    } catch (error) {
      console.error('Failed to stop impersonation:', error);
      setErrorMsg('Failed to stop impersonation. Please try again.');
    }
  };

  return (
    <>
      <Alert
        severity="warning"
        icon={<WarningIcon />}
        sx={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          zIndex: 9999,
          borderRadius: 0,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          backgroundColor: '#ff9800',
          color: 'white',
          '& .MuiAlert-icon': {
            color: 'white'
          },
          '& .MuiAlert-message': {
            flex: 1,
            display: 'flex',
            flexDirection: isMobile ? 'column' : 'row',
            alignItems: isMobile ? 'flex-start' : 'center',
            justifyContent: 'space-between',
            gap: 1,
            width: '100%'
          }
        }}
      >
        <Box display="flex" flexDirection={isMobile ? 'column' : 'row'} alignItems={isMobile ? 'flex-start' : 'center'} gap={isMobile ? 0.5 : 2} flex={1}>
          <Typography variant={isMobile ? 'body2' : 'body1'} fontWeight="bold">
            Viewing as: {user?.full_name}
          </Typography>
          <Typography variant={isMobile ? 'caption' : 'body2'} sx={{ opacity: 0.9 }}>
            Original: {impersonatorName}
          </Typography>
        </Box>
        <Button
          variant="contained"
          color="inherit"
          startIcon={<ExitToAppIcon />}
          onClick={handleStopImpersonation}
          size={isMobile ? 'small' : 'medium'}
          aria-label="Exit impersonation mode"
          sx={{
            backgroundColor: 'white',
            color: '#ff9800',
            fontWeight: 'bold',
            whiteSpace: 'nowrap',
            mt: isMobile ? 1 : 0,
            '&:hover': {
              backgroundColor: '#f5f5f5'
            }
          }}
        >
          Exit
        </Button>
      </Alert>
      <Snackbar
        open={!!errorMsg}
        autoHideDuration={4000}
        onClose={() => setErrorMsg('')}
        message={errorMsg}
      />
    </>
  );
};

export default ImpersonationBanner;

